export const FETCH_ALL_ADS = "FETCH_ALL_ADS";
export const FETCH_SINGLE_AD = "FETCH_SINGLE_AD";
export const FETCH_PENDING_ALL_ADS = "FETCH_PENDING_ALL_ADS";
export const FETCH_ADSBANNERS_SECTIONS="FETCH_ADSBANNERS_SECTIONS"
